import * as React from "react";

import { AuthConsumer } from "../../Providers/AuthProvider";

export const Callback = () => (
    <AuthConsumer>
        {({ signinRedirectCallback }) => {
            signinRedirectCallback();
            return <span></span>;
        }}
    </AuthConsumer>
);